import {ACTIONS as SOCKET_ACTIONS} from '../../constants/socket';

export default (socket) => ({dispatch}) => {
  socket.on('dispatch', (action) => {
    dispatch(action);
  });

  socket.on('disconnect', () => {
    // console.log('should disconnect');
    // socket.disconnect();
  });

  return (next) => (action) => {
    const {type, payload, meta} = action;
    if (meta && meta.socket) {
      if (type === SOCKET_ACTIONS.MESSAGE_CREATE || type === SOCKET_ACTIONS.MESSAGE_TYPING) {
        payload.socketId = socket.id;
      }
      socket.emit(type, payload);
    } else {
      next(action);
    }
  };
};
